<template>
  <el-container class="pagination-list definition-list">
    <el-main>
      <div class="content">
        <el-form :inline="true" @submit.native.prevent>
          <el-form-item>
            <div class="operation">
              <el-input v-model="conditions.keyword" :placeholder="isDataSource === 'true' ? '请输入辅助表名称' : '请输入报表名称'" @keyup.enter.native="search" clearable/>
              <el-button class="search-button" @click="search">查询</el-button>
            </div>
          </el-form-item>
          <el-form-item class="operation-buttons">
            <el-button v-if="isDataSource==='true'" @click="addRow(true)" type="primary">新建辅助表</el-button>
            <el-button v-else @click.stop="addRow(false)" type="primary">新建报表</el-button>
          </el-form-item>
        </el-form>
        <table-list
          ref="tableList"
          :type="this.isDataSource==='true' ? 'dataSourceReport' : 'report'"
          :items="items"
          :cols="cols"
          :loading="loading"
          :pagination="pagination"
          @changePagination="getTableData"
          @editRow="editRow"
          @saveAs="saveAs"
          @delRow="delRow"
          @viewRow="viewReportData"
          @quoteRow="(row) => quoteRow(row, use)"
          @resetReport="(row)=>resetReport(row)">
        </table-list>
      </div>
    </el-main>
    <quote-report-dialog
      @delete="deleteData"
      :quoteDialog="quoteDialog">
    </quote-report-dialog>
    <dialog-report-runtime
      :reportRuntimeDialog="reportRuntimeDialog">
    </dialog-report-runtime>
    <div class="public-design-report-plate-select" v-if="designDialog.plateSelectVisiable">
      <report-plate-select v-if="designDialog.type==='report'" @startDesign="startDesign"></report-plate-select>
    </div>
    <public-design-dialog v-if="designDialog.visiable" :designDialog="designDialog" @closeForm="close"></public-design-dialog>

  </el-container>
</template>

<script>

import TableList from '../../shared/table-list.vue'
import QuoteReportDialog from './quote-report-dialog.vue'
import DialogReportRuntime from '@/components/shared/dialog-report-runtime.vue'
import PublicDesignDialog from '@/components/shared/public-design-dialog.vue'
import ReportPlateSelect from '@/components/report/design/report-plate-select.vue'
export default {
  name: 'reportDesignList',
  props: ['isDataSource'],
  data () {
    let name = this.isDataSource === 'true' ? '辅助表名称' : '报表名称'
    return {
      conditions: {keyword: '', dataSourceReport: ''},
      pagination: {currentPage: 1, pageSize: 20, pageSizes: [10, 20, 30, 50, 100], total: 0},
      loading: false,
      items: [],
      cols: [
        { prop: 'name', label: name, width: '217px' },
        { prop: 'creator', label: '创建人' },
        { prop: 'createTime', label: '创建时间', width: '160px' },
        { prop: 'lastModifiedBy', label: '更新人' },
        { prop: 'lastModifiedDate', label: '更新时间', width: '160px' }
      ],
      filters: {},
      quoteDialog: {
        dialogVisible: false,
        formData: [],
        reportData: [],
        processData: [],
        type: '',
        rowId: '',
        loading: false,
        tableData: []
      },
      reportRuntimeDialog: {
        visible: false,
        id: '',
        type: 'report'
      },
      designDialog: {
        visiable: false,
        id: '',
        type: 'report',
        dataSourceReport: false,
        plateSelectVisiable: false,
        selectPlate: 0,
        changePage: true,
        isResetReport: false
      }
    }
  },
  components: {
    TableList,
    QuoteReportDialog,
    DialogReportRuntime,
    PublicDesignDialog,
    ReportPlateSelect
  },
  created () {
    this.getTableData()
  },
  methods: {
    addRow (flag) {
      this.designDialog.id = ''
      this.designDialog.plateSelectVisiable = !flag
      this.designDialog.visiable = flag
      this.designDialog.dataSourceReport = flag
      this.designDialog.changePage = true
    },
    viewReportData (row) {
      this.reportRuntimeDialog.id = row.id
      this.reportRuntimeDialog.visible = true
    },
    editRow (row) {
      this.designDialog.id = row.id
      this.designDialog.visiable = true
      this.designDialog.dataSourceReport = this.isDataSource === 'true'
      this.designDialog.selectPlate = row.reportType
      this.designDialog.changePage = false
      this.designDialog.isResetReport = false
    },
    resetReport (row) {
      this.designDialog.id = row.id
      this.designDialog.visiable = true
      this.designDialog.selectPlate = row.reportType
      this.designDialog.dataSourceReport = this.isDataSource === 'true'
      this.designDialog.changePage = false
      this.designDialog.isResetReport = true
    },
    startDesign (selectPlate) {
      this.designDialog.visiable = true
      this.designDialog.plateSelectVisiable = false
      this.designDialog.selectPlate = selectPlate
      this.designDialog.dataSourceReport = false
    },
    // 另存为
    saveAs (row, copyLoading) {
      let reportId = row.id
      this.$axios.post(`/report-api/report/definition/saveAs?reportId=${reportId}`)
        .then(() => {
          copyLoading.close()
          this.$message({
            message: '复制成功',
            center: true,
            duration: 1000,
            customClass: 'without-execute-dialog'
          })
          this.search()
        })
        .catch(error => {
          this.$message.error(error.response.data ? error.response.data.message : error.message)
          copyLoading.close()
        })
    },
    delRow (row) {
      if (this.isDataSource === 'true') {
        this.quoteRow(row, 'delete')
      } else {
        this.$confirm('', '你确定要删除吗?', {
          confirmButtonText: '是',
          cancelButtonText: '否',
          customClass: 'deleMessageBox',
          center: true
        }).then(() => this.deleteData(row.id))
      }
    },
    deleteData (reportId) {
      this.$axios.delete('/report-api/report/definition/' + reportId)
        .then(res => {
          this.getTableData()
        })
    },
    quoteRow (row, type) {
      this.quoteDialog.loading = true
      this.quoteDialog.tableData = []
      this.quoteDialog.dialogVisible = true
      if (this.isDataSource === 'true') {
        this.quoteDialog.type = type
        this.quoteDialog.rowId = row.id
      }
      this.$axios.get(`/report-api/report/definition/reference/assist/infos/${row.id}`).then((res) => {
        this.quoteDialog.tableData = res.data
        this.quoteDialog.tableData.forEach(m => {
          switch (m.type) {
            case 'form':
              m.type = '表单'
              break
            case 'report':
              m.type = '报表'
              break
            case 'process':
              m.type = '流程'
              break
          }
        })
        this.quoteDialog.loading = false
      })
    },
    search () {
      // 页数为 1
      this.pagination.currentPage = 1
      this.initParams()
    },
    initParams () {
      this.filters = {
        'keyword': this.conditions.keyword.trim(),
        'isPublish': '',
        'dataSourceReport': this.isDataSource === 'true' ? 'true' : ''
      }
      this.getTableData()
    },
    reset () {
      this.pagination.currentPage = 1
      this.conditions.keyword = ''
      this.conditions.dataSourceReport = this.isDataSource === 'true' ? 'true' : ''
      this.filters = {}
      this.getTableData()
    },
    // 调用接口获取tableData数据
    getTableData () {
      this.loading = true
      let page = this.pagination
      let params = {
        'index': page.currentPage,
        'size': page.pageSize
      }
      this.filters.dataSourceReport = this.isDataSource === 'true' ? 'true' : 'false'
      params.filters = this.filters
      this.$axios.get('/report-api/report/definition', {params})
        .then((res) => {
          // 页面数据改变重新统计数据数量和当前页
          this.pagination.total = res.data.total
          if ((this.pagination.currentPage - 1) * this.pagination.pageSize >= this.pagination.total) {
            this.pagination.currentPage--
            return
          }
          this.items = res.data.items
          this.loading = false
          this.$nextTick(() => {
            // 翻页的时候让滚动条调整到最上方
            if (this.$refs.tableList && this.$refs.tableList.$refs && this.$refs.tableList.$refs.table) {
              this.$refs.tableList.$refs.table.bodyWrapper.scrollTop = 0
            }
          })
        }).catch(() => {
          this.loading = false
        })
    },
    close () {
      if (this.designDialog.changePage) {
        this.pagination.currentPage = 1
      }
      this.initParams()
    }
  },
  mounted () {
    document.getElementById('app').addEventListener('click', () => {
      if (this.designDialog.plateSelectVisiable) {
        this.designDialog.plateSelectVisiable = false
      }
    })
  },
  watch: {
    'quoteDialog.dialogVisible' (val) {
      if (!val) {
        this.quoteDialog.formData = []
        this.quoteDialog.reportData = []
        this.quoteDialog.processData = []
        this.quoteDialog.type = ''
        this.quoteDialog.rowId = ''
      }
    }
  }
}
</script>

<style lang="scss">
  @import '@/assets/scss/common.scss';
  .pagination-list{
    .public-design-report-plate-select {
      position: absolute;
      top: 50px;
      right: 17px;
      width: 357px;
      height: 207px;
      background-color: #fff;
      border-radius: 4px;
      z-index: 999;
      box-shadow: 0 0 4px 3px #EBEBEB;
    }
  }
  .pagination-list {
    .el-main {
      .content {
        .el-form {
          .el-form-item {
            .el-form-item__content {
              .operation {
                display: flex;
                align-items: center;
                .el-button {
                  margin-left: 20px;
                }
              }
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/report/design/definition-list.vue